export default __webpack_public_path__ + "static/PPL_logo_2022_RGB-d14df2dccf18b3d497f23655214c6f3a.png";